<template>
  <div id="totalBox">
    <div class="softwareImgBox">
      <img src="../../assets/product/parkSoftwareBanner.png" alt="" class="softwareImg"/>
    </div>
    <div class="softwareIntroBox">
      <div class="softwarePart">
        <p class="softwarePartTitle">任马停智能识别系统</p>
        <p class="softwarePartTip">（软件功能）</p>
        <div class="softwarePartTotal">
          <ul class="softwarePartBox">
            <li class="softwarePartList softwarePartListTitle">
              <img src="../../assets/product/rightStrangle.png" class="rightIcon" alt="" />
              <div class="softwarePartName">首页</div>
            </li>
            <li class="softwarePartList">标记大巴车</li>
            <li class="softwarePartList">加入黑名单</li>
            <li class="softwarePartList">特殊放行</li>
            <li class="softwarePartList">在场查询</li>
            <li class="softwarePartList">重播金额</li>
          </ul>
          <ul class="softwarePartBox">
            <li class="softwarePartList softwarePartListTitle">
              <img src="../../assets/product/rightStrangle.png" class="rightIcon" alt="" />
              <div class="softwarePartName">系统管理</div>
            </li>
            <li class="softwarePartList">车场信息管理</li>
            <li class="softwarePartList">岗亭管理</li>
            <li class="softwarePartList">设备管理</li>
            <li class="softwarePartList">临时车进出场设置</li>
          </ul>
          <ul class="softwarePartBox">
            <li class="softwarePartList softwarePartListTitle">
              <img src="../../assets/product/rightStrangle.png" class="rightIcon" alt="" />
              <div class="softwarePartName">数据查询</div>
            </li>
            <li class="softwarePartList">车辆查询</li>
            <li class="softwarePartList">换班查询</li>
            <li class="softwarePartList">本地车辆</li>
            <li class="softwarePartList">黑名单查询</li>
          </ul>
          <ul class="softwarePartBox">
            <li class="softwarePartList softwarePartListTitle">
              <img src="../../assets/product/rightStrangle.png" class="rightIcon" alt="" />
              <div class="softwarePartName">数据查询</div>
            </li>
            <li class="softwarePartList">常规设置</li>
            <li class="softwarePartList">高级设置</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="softwareTipBox">
      <div class="softwareTip">
        <p class="softwareTipTitle">适合的才是最好的！</p>
        <div class="softwareTipText">不同的行业有不同的管理方法</div>
        <div class="softwareTipText">我们不要只拘泥于一种形式</div>
        <div class="softwareTipText">只有选择了你最需要的</div>
        <div class="softwareTipText">合作才能是长久的</div>
        <div class="softwareTipText">
                  联系我们
          <img src="../../assets/product/downStrangle.png" class="downIcon"/>
        </div>
        <div class="softwareTipText">定制专属您的车场</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CModel',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
}
.softwareImgBox{
  margin-top: 36px;
  height:580px;
}
.softwareImg{
  width: 1200px;
}
.softwareIntroBox{
  width: 100%;
  height: 620px;
  background-color: RGBA(16, 121, 236, 1);
}
.softwarePart{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding-top: 36px;
}
.softwarePartTitle{
  font-size:38px;
  font-weight:bold;
  color:rgba(255,255,255,1);
}
.softwarePartTip{
  font-size:30px;
  font-weight:400;
  color:rgba(255,255,255,1);
  margin-top: 17px;
}
.softwarePartTotal{
  width: 100%;
  height: 400px;
  background-color: #fff;
  border-radius:20px;
  margin-top: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 42px;
}
.softwarePartBox{
  width: 25%;
  height: 100%;
}
.softwarePartList{
  margin-top: 25px;
  font-size:20px;
  font-weight:400;
  color:rgba(117,117,117,1);
}
.softwarePartListTitle{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  margin-top: 0;
}
.rightIcon{
  width:14px;
  height:20px;
  display: block;
  position: relative;
  top: 3px;
  margin-right: 10px;
}
.softwarePartName{
  font-size:28px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.softwareTipBox{
  width: 1200px;
  margin: 0 auto;
  height: 600px;
  background-image: url(../../assets/product/parkSoftWareBack.png);
  background-position: right;
  background-repeat: no-repeat;
}
.softwareTip{
  width: 430px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.softwareTipTitle{
  font-size:38px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  margin-bottom: 37px;
}
.softwareTipText{
  text-align: left;
  margin-bottom: 15px;
  font-size:20px;
  font-weight:400;
  color:rgba(117,117,117,1);
}
.downIcon{
  width:20px;
  height:26px;
  margin-left: 10px;
  position: relative;
  top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/parkSoftWare.vue